<template>
  <section
    v-if="species && avhandlingar.length > 0 && $_clientMode === 'normal'"
  >
    <v-row class="mt-10">
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3 class="text--secondary">
          Avhandlingar och rapporter
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="avh in avhandlingar"
        :key="avh.id"
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 4"
        class="d-flex child-flex"
      >
        <v-card class="fit">
          <v-img
            :src="$_getImage(avh.article_image_id)"
            max-height="150px"
          ></v-img>
          <v-card-text class="pb-0">
            <div class="subtitle-1 text-uppercase color-primary">
              {{ articleType(avh.article_type) }}
            </div>
          </v-card-text>
          <v-card-title v-html="avh.article_title"> </v-card-title>

          <v-card-text>
            {{ avh.article_description | $_ellipsis(50) }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-2"
              text
              :href="'https://www.havet.nu/' + avh.url"
            >
              Läs
              <v-icon right>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import DataLayer from '@/store/SingleSpeciesDataLayer'
import Misc from '@/mixins/Misc.js'

export default {
  name: 'SpeciesAvhandlingar',
  mixins: [Misc],
  props: {
    species: { type: Object, required: true }
  },
  data() {
    return {
      avhandlingar: []
    }
  },
  mounted() {
    this.setup()
  },
  methods: {
    articleType(type) {
      if (type === 'Lans_rapp') {
        return 'länsstyrelserapport'
      } else if (type === 'MC-rapport') {
        return 'marina centra'
      } else if (type === 'orap') {
        return 'rapport'
      } else {
        return type
      }
    },
    async setup() {
      try {
        const data = await DataLayer.GetRelatedAvhandlingarBySpecName(
          this.species.name_sve
        )
        this.avhandlingar = data
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subtitle-1 {
  color: #7ead61;
}
</style>
